import Education from './Education';

const EducationConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/educacion',
            component: Education
        }
    ]
};

export default EducationConfig;
